<script setup>
import {
  setSelectedCustomer,
  useAvailableCustomers,
  useSelectedCustomer,
  useSelectedCustomerInfo,
} from "@/composables/useCustomer";
import { Dropdown as FDropdown, FeatherIcon } from "frappe-ui";
import { computed, h } from "vue";
import { BButton } from "@/dokos-ui";

const usersIcon = () => h(FeatherIcon, { name: "users" });
const selectedIcon = () => h(FeatherIcon, { name: "check" });
const allCustomers = useAvailableCustomers();
const currentCustomer = useSelectedCustomer();
const currentCustomerInfo = useSelectedCustomerInfo();

const options = computed(() => {
  return [
    {
      group: "Mes organisations",
      items: allCustomers.value.map(({ name, customer_name }) => {
        return {
          label: customer_name,
          icon: name == currentCustomer.value ? selectedIcon : usersIcon,
          onClick: () => setSelectedCustomer(name),
        };
      }),
    },
  ];
});
</script>

<template>
  <FDropdown class="!px-0" :options="options">
    <template #default="{ open }">
      <BButton variant="soft" as="div" class="flex">
        <FeatherIcon name="users" class="size-4" />
        <div class="max-md:hidden leading-[1] font-semibold text-gray-800">
          {{ currentCustomerInfo?.customer_name }}
        </div>
        <FeatherIcon
          class="size-4 transition -mr-1"
          :class="open && '-rotate-180'"
          name="chevron-down"
        />
      </BButton>
    </template>
  </FDropdown>
</template>
